import Image from 'next/image';
import Link from 'next/link';

const year = new Date().getFullYear();

const productLinks = [
  { href: '/', label: 'Home' },
  { href: '/rotations', label: 'Rotations' },
  { href: '/pricing', label: 'Pricing' },
  { href: '/apply/np', label: 'NP Application' },
  { href: '/dsu', label: 'DSU PMHNP' },
];

const companyLinks = [
  { href: '/about', label: 'About' },
  { href: '/testimonials', label: 'Testimonials' },
  { href: '/faq', label: 'FAQ' },
  { href: '/contact', label: 'Contact' },
  { href: '/', label: 'NP Students' },
  { href: '/contact', label: 'PA Students' },
  { href: '/img', label: 'IMG Students' },
];

const supportLinks = [
  { href: '/auth/login', label: 'Login' },
];

export default function SiteFooter() {
  return (
  <footer className="border-t border-[var(--brand-border)] bg-white/95 backdrop-blur text-[var(--brand-muted)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 space-y-10">
        {/* Top informational + navigation (condensed to 4 columns) */}
        <div className="flex flex-col md:flex-row gap-8 md:gap-14 md:items-start">
          {/* Brand / Mission (flex expands) */}
          <div className="flex-1 min-w-[260px] max-w-md space-y-4">
            <Link href="/" className="flex items-center gap-3">
              <Image
                src="/images/Ace-Main-Logo.png"
                alt="American Clinical Experience"
                width={160}
                height={80}
                className="h-12 w-auto object-contain drop-shadow-sm"
                loading="lazy"
              />
              <span className="flex flex-col leading-tight">
                <span className="text-lg font-bold tracking-tight bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                  American <span className="font-semibold">Clinical</span> Experience
                </span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed max-w-sm text-[var(--brand-muted)]/90">
              Helping students streamline their clinical rotations since 2014!
            </p>
            <div className="pt-2">
              <p className="text-xs font-medium tracking-wide uppercase text-[var(--brand-muted)]/70">Shape Your Future</p>
              <p className="mt-1 text-sm"><Link href="mailto:info@acerotations.com" className="hover:text-[var(--brand-primary)] underline underline-offset-4">info@acerotations.com</Link></p>
              <p className="mt-2 text-[10px] text-[var(--brand-muted)]/70">Made with <span aria-label="love">♥</span> in Los Angeles</p>
            </div>
          </div>

          {/* Link Columns — 2-col grid on mobile, inline on md+ via display:contents */}
          <div className="grid grid-cols-2 gap-6 md:contents">
            <div className="md:w-40 shrink-0">
              <h4 className="text-sm font-semibold tracking-wide uppercase text-[var(--brand-muted)]/80 mb-3">Company</h4>
              <ul className="space-y-2">
                {companyLinks.map(l => (
                  <li key={l.label}><Link href={l.href} className="hover:text-[var(--brand-primary)] transition-colors text-sm">{l.label}</Link></li>
                ))}
              </ul>
            </div>
            <div className="md:w-40 shrink-0">
              <h4 className="text-sm font-semibold tracking-wide uppercase text-[var(--brand-muted)]/80 mb-3">Product</h4>
              <ul className="space-y-2">
                {productLinks.map(l => (
                  <li key={l.href}><Link href={l.href} className="hover:text-[var(--brand-primary)] transition-colors text-sm">{l.label}</Link></li>
                ))}
              </ul>
            </div>
          </div>
          <div className="md:w-48 shrink-0">
            <h4 className="text-sm font-semibold tracking-wide uppercase text-[var(--brand-muted)]/80 mb-3">Access & Partners</h4>
            <ul className="space-y-2 mb-4">
              {supportLinks.map(l => (
                <li key={l.href}><Link href={l.href} className="hover:text-[var(--brand-primary)] transition-colors text-sm">{l.label}</Link></li>
              ))}
            </ul>
            <div className="flex items-center gap-4 mb-4">
              {/* BBB Seal */}
              <a href="https://www.bbb.org/us/ca/west-hollywood/profile/employment-agencies/american-clinical-experience-1216-723884" target="_blank" rel="noopener noreferrer" className="w-[180px] h-[42px] relative">
                <Image
                  src="/images/american-clinical-experience-723884.png"
                  alt="BBB Accredited"
                  fill
                  className="object-contain"
                  sizes="180px"
                  loading="lazy"
                />
              </a>
            </div>
          </div>
        </div>
        {/* Bottom legal + meta */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 border-t border-[var(--brand-border)] pt-6">
          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6 text-xs">
            <span className="text-[var(--brand-muted)]/80">© {year} ACE Rotations.</span>
            <span className="text-[var(--brand-muted)]/60">All rights reserved.</span>
          </div>
          <div className="flex flex-wrap items-center gap-4 text-[11px] font-medium">
            <Link href="/terms" className="hover:text-[var(--brand-primary)] underline-offset-4 hover:underline">Terms of Service</Link>
            <Link href="/terms" className="hover:text-[var(--brand-primary)] underline-offset-4 hover:underline">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
